module.exports = __webpack_public_path__ + "img/chemistry.84447648.jpg";